type TabKeys = 'Online' | 'Flywire' | 'Offline' | 'Travel Card' | 'Convera';

interface TabShifterProps {
  list: TabKeys[];
  selectedItem: TabKeys;
  handleClick: (tabName: TabKeys) => void;
}

const TabShifter = ({ list, selectedItem, handleClick }: TabShifterProps) => {
  if (list?.length > 0) {
    return (
      <div className="w-full border-b flex">
        {list.map((tabName, index) => (
          <div
            onClick={() => handleClick(tabName)}
            key={index}
            className={`max-w-fit cursor-pointer ${
              selectedItem === tabName ? "border-tabshifter border-b-4" : ""
            }`}
          >
            <label className="font-medium text-lg pr-4">{tabName}</label>
          </div>
        ))}
      </div>
    );
  }
  return null;
};

export default TabShifter;
